import { Component, EventEmitter, Input, Output } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-confirm-delecao',
  templateUrl: './modal-confirm-delecao.component.html',
  styleUrl: './modal-confirm-delecao.component.scss'
})
export class ModalConfirmDelecaoComponent {

  // Tipo de lançamento: 1 = Avulsa, 2 = Parcelada, 3 = Recorrente
  @Input() tipoLancamento: number | null = null;
  // Descrição do item para exibir na mensagem
  @Input() descricao: string = '';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  showConfirmDialog(): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });

    // Gerar mensagem de alerta baseada no tipo de lançamento
    let alertHtml = '';
    if (this.tipoLancamento === 2) {
      // Parcelado
      alertHtml = `
        <div class="alert alert-warning mt-3 mb-0" role="alert">
          <i class="fas fa-info-circle me-2"></i>
          <strong>Atenção:</strong> Ao excluir um lançamento parcelado, apenas as parcelas futuras que ainda não foram pagas/recebidas serão removidas.
          <br><small>Se preferir, você pode cancelar apenas uma parcela específica, sem afetar as demais.</small>
        </div>
      `;
    } else if (this.tipoLancamento === 3) {
      // Recorrente
      alertHtml = `
        <div class="alert alert-warning mt-3 mb-0" role="alert">
          <i class="fas fa-info-circle me-2"></i>
          <strong>Atenção:</strong> Ao excluir um lançamento recorrente, apenas as ocorrências futuras que ainda não foram pagas/recebidas serão removidas.
          <br><small>Se preferir, você pode cancelar apenas um lançamento específico, sem interromper toda a recorrência.</small>
        </div>
      `;
    }

    const messageText = this.descricao
      ? `Você não poderá reverter isso! O item "<strong>${this.descricao}</strong>" será excluído.${alertHtml}`
      : `Você não poderá reverter isso!${alertHtml}`;

    swalWithBootstrapButtons
      .fire({
        title: 'Continuar Excluindo?',
        html: messageText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir',
        cancelButtonText: 'Não, cancelar!'
      })
      .then(result => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Excluído!',
            'Seu item foi excluído.',
            'success'
          );
          this.confirm.emit();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            'Cancelado',
            'Seu item continua seguro :)',
            'error'
          );
          this.cancel.emit();
        }
      });
  }

}
